// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import cn from 'classnames';
import styles from './card.module.less';
import {Button} from '../../../../hola/pub/lib/button';
import {useHistory} from 'react-router-dom';
import {use_app_context} from '../../../../toolip/pub/lib/app_context';
import {oculus_proxy_type} from '../../types';

interface i_card_props {
    plan_id: string,
    amount: string,
    price: string,
    subtitle: string,
    bandwidth: {text: string, unlimited?: boolean},
    is_popular?: boolean,
    is_free?: boolean,
    badge?: {free?: boolean, popular?: boolean, color?: string, text: string},
    mobile?: boolean,
    type: oculus_proxy_type,
    is_all_sold_out?: boolean;
    is_sold_out?: boolean;
    set_modal?: (id: string, plan_id?: string) => void;
}

export const Card = (props: i_card_props)=>{
    const {amount, price, subtitle, bandwidth, badge, plan_id, mobile,
        is_all_sold_out, is_sold_out, type, set_modal}= props;
    const {theme} = useContext(Settings_context);
    const {dashboard} = use_app_context();
    const {dispatch} = dashboard;
    const history = useHistory();
    const badge_text = badge?.text;
    const button_caption = badge?.free ? 'Start now' : 'Buy now';
    const button_color = is_sold_out ? 'transparent' : badge?.free ? 'orchid'
        : badge?.popular ? '' : 'transparent';
    const badge_color_class = badge?.popular && badge.color ?
        styles[`popular_badge_${badge.color}`] : '';
    const sold_out_badge = {
        sold_out: true,
        text: 'SOLD OUT!',
        color: styles.sold_out_badge,
    };
    const button_to = `/pricing/checkout?plan_id=${plan_id}`;
    const is_smart_resi = type === 'smart_resi';
    const detected_button_to = is_smart_resi ? null : button_to;
    const card_cls = cn(styles.card, mobile && styles.mobile_card,
        is_sold_out ? styles.sold_out :
            styles.card, badge?.free && styles.free_card,
            badge?.popular && styles.popular_card);
    return <div className={card_cls}>
      {!is_all_sold_out && (badge || is_sold_out) &&
      <div className={cn(styles.badge,
        badge?.free && styles.free_badge,
        badge?.popular && badge_color_class,
        is_sold_out && sold_out_badge.color)}>{is_sold_out ?
          sold_out_badge.text : badge_text}</div>}
      {!mobile ? <div className={styles.upper}>
        <div className={styles.amount}>
          <p className={cn(theme.p18, theme.bold,
            is_sold_out && theme.color_n400)}>{amount}</p>
        </div>
        <div className={styles.price}>
          <h4 className={cn(theme.H4, theme.bold)}>{price}</h4>
        </div>
        <div className={styles.subtitle}>
          <p className={cn(theme.p16, theme.reg,
            is_sold_out && theme.color_n400)}>{subtitle}</p>
        </div>
      </div> :
      <div className={styles.upper}>
        <div className={styles.amount}>
          <p className={cn(theme.p16, theme.bold,
            is_sold_out && theme.color_n400)}>{amount}</p>
        </div>
        <div className={styles.mobile_price}>
          <h5 className={cn(theme.H5, theme.bold)}>{price}</h5>
          <div className={styles.mobile_subtitle}>
            <p className={cn(theme.p14, theme.reg,
              is_sold_out && theme.color_n400)}>{subtitle}</p>
          </div>
        </div>
    </div>
      }
      <div className={styles.lower}>
        {bandwidth && <div className={cn(styles.bandwidth,
          bandwidth?.unlimited && styles.unlimited)}>
            <p className={cn(theme.p14, theme.med)}>{bandwidth.text}</p>
        </div>}
        {is_sold_out ? <Button caption={button_caption} color={button_color}
          cls={cn(styles.btn, styles.sold_out_btn)} round={false}/> :
          badge?.free ?
            <Button caption={button_caption} color={button_color} round={false}
              on_click={()=>{
                dispatch({type: 'create_free_zone', payload: {type}});
                history.push('/dashboard/page/plans');
              }} cls={styles.btn}/> : <Button caption={button_caption}
                color={button_color} round={false} cls={styles.btn}
                to={detected_button_to}
                on_click={()=>is_smart_resi &&
                  set_modal('read_only', plan_id)}/>}
      </div>
    </div>;
};
